module.exports = __webpack_public_path__ + "img/manage-merchant_active.29ebb5d1.svg";